import { createSelector } from '@reduxjs/toolkit';
import { selectCmsFromBootstrap, selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { selectPageTypeId } from 'store/slice/navigation';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { Pagination } from 'gql/autogen/Pagination';
import { ScreenSize, selectScreenSize } from 'store/slice/screen';
import { selectActivityFromDetailState } from 'component/page/detail/store/detail.selectors';

interface StateProps {
    pageTypeId: number;
    cms: CmsValue;
    pagination?: Pagination;
    screenSize: ScreenSize;
    categoryId?: string;
    cityId?: number;
    cityName?: string;
    activityId?: number;
}
export type ExploringActivitiesCarouselProps = StateProps;

export const mapStateToProps = createSelector(
    selectActivityFromDetailState,
    selectCmsFromBootstrap,
    selectPageTypeId,
    selectScreenSize,
    selectFeatureBehaviorFromBootstrap,
    (activity, cms, pageTypeId, screenSize): StateProps => {
        const activityContent = activity.content || {};
        const categoryId = activityContent?.activity?.categories?.[0];
        const cityId = activityContent?.activity?.location?.city?.id;
        const cityName = activityContent?.activity?.location?.city?.name;
        const activityId = activity.masterActivityId || 0;

        return { pageTypeId, cms, screenSize, categoryId, cityId, cityName, activityId };
    },
);
